import { render, staticRenderFns } from "./NoteThreadChatForm.vue?vue&type=template&id=6aaf8d15&"
import script from "./NoteThreadChatForm.vue?vue&type=script&lang=ts&"
export * from "./NoteThreadChatForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports